import { useEffect, useRef } from 'react';
import Styles from '../../Pages/HomeLayout.module.css';
export default function ScrollProgress() {
    const bar = useRef(null);
    useEffect(() => {
        let frame = 0;
        let range = 0;
        const paint = () => {
            frame = 0;
            const progress = range > 0 ? Math.min(1, Math.max(0, window.scrollY / range)) : 0;
            if (bar.current) bar.current.style.transform = 'scaleX(' + progress + ')';
        };
        const schedule = () => { if (!frame) frame = requestAnimationFrame(paint); };
        const measure = () => {
            range = Math.max(0, document.documentElement.scrollHeight - document.documentElement.clientHeight);
            schedule();
        };
        const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
        observer?.observe(document.body);
        observer?.observe(document.documentElement);
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', measure, { passive: true });
        measure();
        return () => {
            cancelAnimationFrame(frame);
            observer?.disconnect();
            window.removeEventListener('scroll', schedule);
            window.removeEventListener('resize', measure);
        };
    }, []);
    return <article className={Styles.scrollcontainer} aria-hidden="true"><article ref={bar} className={Styles.scroll} /></article>;
}
